module.exports = __webpack_public_path__ + "static/EGH_Mobx_Final-a4da56da8b80295aac2034ea5f0f8916.png";